<!-- Loading bar -->
<!-- <fuse-loading-bar></fuse-loading-bar> -->

<!-- Navigation -->
<fuse-vertical-navigation class="bg-card sidebar-shell print:hidden overflow-hidden" [appearance]="navigationAppearance"
    [mode]="isScreenSmall || hideSidebar ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="currentNavigation"
    [opened]="!hideSidebar && !isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex w-full flex-col items-stretch gap-3 pb-2 pt-4">
            <!-- Logo -->
            <div class="sidebar-logo flex items-center justify-center px-4">
                <a [routerLink]="homeLink"
                    [attr.aria-label]="isSuperAdmin ? 'My Home' : 'Accounting dashboard'"
                    class="flex w-full cursor-pointer items-center justify-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                    @if (navigationAppearance === 'dense' && !isScreenSmall) {
                    <img class="w-8" src="images/logo/logo.svg" alt="BizCare" />
                    } @else {
                    <img class="w-[78%]" src="images/logo/bizcare_logo.svg" alt="BizCare" />
                    }
                </a>
            </div>
        </div>
        <!-- User -->
        <!-- <div class="flex w-full flex-col items-center p-4">
            <div class="relative h-24 w-24">
                @if (user.avatar) {
                    <img
                        class="h-full w-full rounded-full"
                        [src]="user.avatar"
                        alt="User avatar"
                    />
                }
                @if (!user.avatar) {
                    <mat-icon
                        class="icon-size-24"
                        [svgIcon]="'heroicons_solid:user-circle'"
                    ></mat-icon>
                }
            </div>
            <div class="mt-6 flex w-full flex-col items-center justify-center">
                <div
                    class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal"
                >
                    {{ user.name }}
                </div>
                <div
                    class="text-secondary mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center text-md font-medium leading-normal"
                >
                    {{ user.email }}
                </div>
            </div>
        </div> -->
    </ng-container>
    <!-- Sidebar footer -->
    <ng-container fuseVerticalNavigationFooter>
        <sidebar-account class="sidebar-footer-account"></sidebar-account>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-h-0 min-w-0 flex-auto flex-col overflow-hidden">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden">
        <!-- Navigation toggle button (hidden on My Home — full-width, no sidebar) -->
        @if (!hideSidebar) {
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        }
        <!-- Components -->
        <div class="mr-auto flex min-w-0 flex-1 items-center">
            <!-- Desktop: scrollable module pills with edge arrows -->
            <div
                class="module-nav-shell !hidden md:!flex"
                [class.module-nav-shell--left]="canScrollModulesLeft"
                [class.module-nav-shell--right]="canScrollModulesRight">
                @if (canScrollModulesLeft) {
                <button
                    type="button"
                    class="module-nav-arrow module-nav-arrow--left"
                    aria-label="Previous modules"
                    (click)="scrollModules('left')">
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_outline:chevron-left'"></mat-icon>
                </button>
                }
                <nav
                    #moduleNav
                    class="module-nav"
                    (scroll)="onModuleNavScroll()">
                    @for(item of headerModules; track item.key){
                    <a
                        [routerLink]="item.link"
                        [class.active-nav]="activeModule === item.key"
                        class="nav-pill"
                        [attr.data-module-key]="item.key"
                        [matTooltip]="item.label"
                        matTooltipPosition="below">
                        <mat-icon class="icon-size-5" [svgIcon]="item.icon"></mat-icon>
                        <span class="nav-label">{{ item.label }}</span>
                    </a>
                    }
                </nav>
                @if (canScrollModulesRight) {
                <button
                    type="button"
                    class="module-nav-arrow module-nav-arrow--right"
                    aria-label="More modules"
                    (click)="scrollModules('right')">
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_outline:chevron-right'"></mat-icon>
                </button>
                }
            </div>

            <!-- Mobile: modules in 3-dots overflow menu -->
            <button
                type="button"
                mat-icon-button
                class="md:hidden"
                [matMenuTriggerFor]="modulesMenu"
                aria-label="Modules"
                matTooltip="Modules"
                matTooltipPosition="below">
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #modulesMenu="matMenu">
                @for(item of headerModules; track item.key){
                <a
                    mat-menu-item
                    [routerLink]="item.link"
                    [class.active-module]="activeModule === item.key">
                    <mat-icon class="icon-size-5" [svgIcon]="item.icon"></mat-icon>
                    <span>{{ item.label }}</span>
                </a>
                }
            </mat-menu>
        </div>
        <div class="ml-auto flex flex-none items-center space-x-0.5 pl-2 sm:space-x-2">
            <!-- <languages></languages> -->

              <!-- <search [appearance]="'bar'"></search>
            <shortcuts></shortcuts> -->
            <!-- <messages></messages> -->
            <approval-inbox-button></approval-inbox-button>
            <reminders-header-button></reminders-header-button>
            <notifications></notifications>
            <user></user>
            <!-- <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()"
            >
                <mat-icon
                    [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                ></mat-icon>
            </button> -->
        </div>
    </div>

    <!-- Sticky under module header for the whole session when profile.billing requires attention -->
    <app-scb-tenant-billing-banner class="shrink-0"></app-scb-tenant-billing-banner>

    <!-- Page scrollport for details / dashboards / forms (lists absolute-fill + scroll inside). -->
    <div class="classy-main-content min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto bg-card dark:bg-default">
        @if (showNoPermissions) {
        <no-permissions></no-permissions>
        } @else {
        <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->

<!-- <guided-help></guided-help> -->